import React, { useEffect, useState } from 'react';
import downloadIcon from "../../../assets/images/download.png";
import { DownloadFileFeedService } from "../../../services/PostsAndFeedService";
import axios from 'axios';
import { popupConfirmDeleteWarning } from '../../../utils/Popups';
import { RenderAttachList } from '../../common/RenderAttachListFeed';
import Swal from 'sweetalert2';
import { IMAGE_URL } from '../../../utils/Constants';
import { buildAbsoluteDownloadUrl } from '../../../utils/FileDownload';
import '../../../assets/css/flexibleModalLegacy.css';


function FeedAttachments({ attachments, isEditable, allData, deletedFile, setDeletedFileData = null }) {

    const [images, setImages] = useState([]);
    const [downloads, setDownloads] = useState([]);
    const [currentimage, setcurrentimage] = useState('');
    const [attachArr, setAttachArr] = useState([]);
    const [seeMore, setSeeMore] = useState(false);
    const [seeLess, setSeeLess] = useState(false);

    useEffect(() => {
        setAttachArr(attachments)
    }, [attachments])

    useEffect(() => {
        const imageArr = attachArr.filter(item => {
            return item.fileType === "render"
        })
        const downloadArr = attachArr.filter(item => {
            return item.fileType === "download"
        })
        setDownloads(downloadArr);
        setImages(imageArr);
        if (imageArr.length > 0) {
            setSeeMore(true)
        }

    }, [attachArr]);

    useEffect(() => {
        if (isEditable) {
            setSeeMore(false)
            setSeeLess(false)
        }
        else if(images.length>0){
            setSeeMore(true)
        }
    }, [isEditable])


    const forceFileDownload = (response, item) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', item.originalName) //or any other extension
        document.body.appendChild(link)
        link.click()
    }

    const handleRemoveFile = (props) => {
        popupConfirmDeleteWarning((result) => {
            if (result.isConfirmed) {
                deletedFile(allData.id, props.filePath)

                let tempArr = []
                attachArr.map(i => {
                    if (props.filePath != i.attachment) {
                        tempArr.push(i)
                    }
                })
                setAttachArr(tempArr);
                if(allData.attachments?.length > 0 && setDeletedFileData !== null){
                    setDeletedFileData(prev => {
                        const newItems = Array.isArray(props) ? props : [props];
                        return [...prev, ...newItems];
                    });
                }
            }
        });
    };

    const delImg = (item) => {
        item.filePath = item.attachment
        handleRemoveFile(item)
    }

    return (
        <>
            <div >
                <div className="attachment-container">
                    <div className={`image-container`} onClick={(e)=>e.stopPropagation()}>
                        <ul className="post-image-ul list_post_imgview">
                            {images.map((item) => {
                                return (
                                    <li className="post-image" key={item.id}>
                                        {isEditable ?
                                            <button onClick={() => { delImg(item) }} type="button" className="btn file-remove-btn img-del"><i class="fal fa-times hold-show"></i></button>
                                            :
                                            null
                                        }
                                        {item.attachment ? (
                                            <img
                                                className="hold-show"
                                                src={buildAbsoluteDownloadUrl(item.attachment)}
                                                alt="chatImage"
                                                onClick={() => setcurrentimage(buildAbsoluteDownloadUrl(item.attachment))}
                                            />
                                        ) : ""}
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                </div>
                {downloads?.length > 0 && <div className="files-list-blk files-container">
                    <ul className="files-container-ul">
                        {downloads.map((item) => {
                            return (
                                <li className="files-container-li" key={item.id}>
                                    {RenderAttachList({
                                        fileName: item.originalName,
                                        size: item.size,
                                        filePath: item.attachment,
                                        showClose: isEditable,
                                        handleRemoveFile: handleRemoveFile
                                    })}
                                </li>
                            )
                        })}
                    </ul>
                </div>}

                <div onClick={() => { }} className={`image-popup-block ${currentimage != '' ? 'active' : ''}`}>
                    <div className="image-popup flexible-modal">
                        <button type="button" onClick={() => { setcurrentimage('') }} className="close-icon"><i class="fas fa-times hold-show"></i></button>
                        <div className="image-popup-img">
                            <img src={currentimage} />
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default React.memo(FeedAttachments);